module.exports = __webpack_public_path__ + "img/addWinnerInvoiceGif.e86f8bb9.gif";